import { MUTATION } from '@skooldio/classroom-frontend-api';
import { gql } from 'graphql-tag';

const {
  enterClassroom,
  enterClassroomQuizSession,
  verifyClassroom,
  submitClassroomQuizAnswer,
  submitClassroomQuizAnswers,
  gradeClassroomQuizExamPaper,
  // generateClassroomAssetSignedUrl, // deprecated: use generateClassroomCourseAssetSignedUrls
  // generateClassroomAssetSignedUrls, // deprecated: use generateClassroomCourseAssetSignedUrls
  generateClassroomVideoSignedUrl,
  generateClassroomVideoScreenshotSignedUrl,
  generateClassroomVideoSignedUrlBySourceType,
  generateClassroomLiveSignedUrl,
  updateClassroomCurrentSubSection,
  updateClassroomSubSectionVideoProgress,
  updateClassroomTimeCompleteCourseItem,
  updateClassroomQuizSimpleResult,
  updateUserAsset,
  updateClassroomCurrentLearningMode,
} = MUTATION.Classroom;

const generateAssetSignedUrlsByAssetId = gql`
  mutation generateAssetSignedUrlsByAssetId($classroomId: ID!, $sourceCourseAssetId: ID!) {
    generateClassroomCourseAssetSignedUrls(
      classroomId: $classroomId
      sourceCourseAssetId: $sourceCourseAssetId
    ) {
      code
      success
      message
      urls {
        key
        signedUrl
      }
    }
  }
`;

const updateClassroomTimeActivities = gql`
  mutation updateClassroomTimeActivities(
    $classroomTimeId: ID!
    $classroomId: ID!
    $courseId: ID!
    $subSectionReferId: ID!
    $timeSpending: Int!
    $learningMode: String
    $subsectionRevisionId: String
    $isCompleted: Boolean
    $subject: String
    $isBonusContent: Boolean
    $mode: String
    $courseRevisionId: String
  ) {
    updateClassroomTimeActivities(
      classroomTimeId: $classroomTimeId
      classroomId: $classroomId
      courseId: $courseId
      subSectionReferId: $subSectionReferId
      timeSpending: $timeSpending
      learningMode: $learningMode
      subsectionRevisionId: $subsectionRevisionId
      isCompleted: $isCompleted
      subject: $subject
      isBonusContent: $isBonusContent
      mode: $mode
      courseRevisionId: $courseRevisionId
    ) {
      code
      success
      message
      classroomTime {
        classroomTimeId
        remainingTime
        isValidRemainingTime
        type
      }
    }
  }
`;

const updateClassroomSubsectionStatus = gql`
  mutation updateClassroomCurrentSubSection(
    $classroomId: ID!
    $subSectionReferId: ID!
    $sourceType: String
    $status: CLASSROOM_SUBSECTION_STATUS
    $learningMode: String
  ) {
    updateSubSectionStatus(
      classroomId: $classroomId
      subSectionReferId: $subSectionReferId
      sourceType: $sourceType
      status: $status
      learningMode: $learningMode
    ) {
      code
      success
      message
      subSectionStatus {
        id
        subSectionStatus {
          courseItemReferId
          status
          createdAt
        }
      }
    }
  }
`;

const earnUserPoint = gql`
  mutation EarnUserPoint($sourceCourseId: ID!, $classroomId: ID!, $courseItemId: ID!) {
    earnUserPoint(
      sourceCourseId: $sourceCourseId
      classroomId: $classroomId
      courseItemId: $courseItemId
    ) {
      code
      success
      message
      userPoint {
        isEarnComplete
        earnTotal
        earnPoints {
          missionName
          pointType
          earnPoint
        }
      }
    }
  }
`;

export {
  earnUserPoint,
  enterClassroom,
  enterClassroomQuizSession,
  generateAssetSignedUrlsByAssetId,
  // generateClassroomAssetSignedUrl, // deprecated: use generateClassroomCourseAssetSignedUrls
  // generateClassroomAssetSignedUrls, // deprecated: use generateClassroomCourseAssetSignedUrls
  generateClassroomLiveSignedUrl,
  generateClassroomVideoScreenshotSignedUrl,
  generateClassroomVideoSignedUrl,
  generateClassroomVideoSignedUrlBySourceType,
  gradeClassroomQuizExamPaper,
  submitClassroomQuizAnswer,
  submitClassroomQuizAnswers,
  updateClassroomCurrentLearningMode,
  updateClassroomCurrentSubSection,
  updateClassroomQuizSimpleResult,
  updateClassroomSubsectionStatus,
  updateClassroomSubSectionVideoProgress,
  updateClassroomTimeActivities,
  updateClassroomTimeCompleteCourseItem,
  updateUserAsset,
  verifyClassroom,
};
